import * as React from 'react'
import { ThemeContext } from 'embed/components/ThemeProvider'

export const useTheme = () => React.useContext(ThemeContext)
